module.exports = __webpack_public_path__ + "static/cereal-0fd42bef91f072107281fd1db5c6717a.svg";